import { lighten } from '@material-ui/core/styles/colorManipulator';

export const styles = theme => ({
    root: {
      // width: '100%',
      backgroundColor: theme.palette.background.paper,
      paddingBottom: 0
    },
    titleContainer: {
        marginBottom: theme.spacing(3),
    },
    subTitle: {
        fontWeight: '500',
        fontSize: '0.85rem',
        cursor: 'pointer',
    },
    menuName: {
      cursor: 'pointer',
      wordWrap: 'break-word',
    },
    body: {
      cursor: 'pointer',
    },
    iconEdit : {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    limit: {
      lineHeight:'1.3rem',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    title: {
      flex: '0 0 auto',
    },
    TextFieldGroup: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',

      '@media only screen and (min-width:600.98px) and (max-width:958px) ': {
        flexBasic: '100%',
        maxWidth: '100%'
      },
      '@media only screen and (min-width:480px) and (max-width:600px) ': {
        flexBasic: '100%',
        maxWidth: '100%'
      }
    },
    //toolbar
    rootToolbar: {
      paddingRight: theme.spacing(1),
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    spacer: {
      flex: '1 1 100%',
    },
    actions: {
      color: theme.palette.text.secondary,
    },
    textField: {
      // marginLeft: theme.spacing(1),
      // marginRight: theme.spacing(1),
      width: '20%',
      float: 'right'
    },
    icon: {
      marginTop: theme.spacing(3),
      width: 36,
      height: 36,
      left: -8
    },
    // modify 
    toolbarContainer:{
      height: '12%'
    },
    textFieldModal: {
      display: 'block',
    },

    inputModal: {
      width: '500px',
    },
    paper: {
      position: 'absolute',
      // width: theme.spacing(50),
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
    },
    buttonModal: {
      marginTop: '16px',
      textAlign: 'right',
    },
    paperWidthSm: {
      width: '50%',
      maxWidth: 'unset',
    },
    rootTitle: {
      borderBottom: "1px solid #80808026"
    }
})


export const tablecellStyles = theme => ({
  head: {
    textTransform: 'capitalize'
  }
});

export const textFieldStyles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '16px',
    padding: '24px 24px ',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  textField: {
    width: '100%',    
  },
  menu: {
    width: '15%',
  },
  input: {
    
    // fontSize : 18
  },
  label: {
    
    fontWeight: 410
  },
  actives: {
    fontSize: 16,    
    marginLeft: '60px',
    display: 'inline-block'
  },
  subMenu:{
    paddingLeft: theme.spacing(1)
  },
  button: {
    // marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  switchBase: {
    '&$switchChecked': {
      color: theme.palette.common.white,
      '& + $switchBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  switchChecked: {
    transform: 'translateX(15px)',
    '& + $switchBar': {
      opacity: 1,
      border: 'none',
    },
  },
  switchBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  switchIcon: {
    width: 24,
    height: 24,
  },
  switchIconChecked: {
    boxShadow: theme.shadows[1],
  },
  // modify
  buttonContainer:{
    display: 'flex',
    flexDirection:'row',
    justifyContent:'flex-end'
  },
});


export const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  textField: {
    // marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
    width: '20%',
    float: 'right'
  },
  icon: {
    marginTop: theme.spacing(3),
    width: 36,
    height: 36,
    left: -8
  },
  // modify 
  toolbarContainer:{
    height: '12%'
  }
});
